import type {
  CertificateLike,
  ProgressLike,
  XapiContext,
  XapiServiceLike,
} from '@efdigital/ll-addon-content/types/services/xapi-like';
import Service from '@ember/service';

/**
 * Stub xAPI service for ll-admin-v2
 * This application doesn't track xAPI progress, but some components
 * (like ResourceListing) expect this service to exist.
 */
export default class XapiService extends Service implements XapiServiceLike {
  isPageComplete(_ctx: XapiContext): Promise<boolean> {
    return Promise.resolve(false);
  }

  getContentPackage(_id: string, _version: number): Promise<string> {
    return Promise.resolve('');
  }

  getCertificate(_type: string, _id: string): Promise<CertificateLike> {
    return Promise.resolve({
      date: '',
      license: '',
      evidence: '',
      badge: '',
      complete: false,
      statements: [],
    });
  }

  sendStatements(_statements: unknown[]): void {
    // No-op in admin context
  }

  getContentPackageProgress(
    _id: string,

    _version: number | 'all'
  ): Promise<ProgressLike> {
    return Promise.resolve({
      packages: [],
      resource: {
        percent: 0,
      },
    });
  }
}
